import { render } from "./VisitasView.vue?vue&type=template&id=5689791b"
import script from "./VisitasView.vue?vue&type=script&lang=js"
export * from "./VisitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__